import React, { Component }from 'react';

export default class NotFound extends Component  {

  
    constructor(props) {
        super(props);
        this.state = { error: null };
        //console.dir(props);
    }
    async  componentDidMount() {
        const resp = await fetch('/landing/error/0', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        }          
        );       
        if (resp.status === 200) {
            var content = await resp.text();
            this.setState({ error: content }) 
        }
            
    
    }
   
    render() {
        let errordisp = this.state.error
        return (
            <div>
                <p dangerouslySetInnerHTML={{ __html: errordisp }} />
            </div>

        );
    }
       
    
}


